var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.watchlistItem
    ? _c(
        "div",
        [
          _c(
            "div",
            [
              !_vm.virtual && !_vm.emit
                ? _c("q-toggle", {
                    attrs: {
                      value: _vm.showBundleImages,
                      label: _vm.$t("label.showBundleImages"),
                      disable: _vm.updating
                    },
                    on: { input: _vm.updateShowBundleImages }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.showBundleViewer
            ? _c(
                "div",
                [
                  _c("bundle-viewer", {
                    staticClass: "q-my-sm",
                    attrs: {
                      log: _vm.log,
                      isVirtual: _vm.virtual || _vm.props.isVirtual,
                      height: 200
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.allSmallImages.length
            ? [
                _vm.watchlistItem && _vm.watchlistItem.teaser
                  ? _c(
                      "div",
                      { staticClass: "row q-my-md relative-position" },
                      [
                        _c("p", { staticClass: "text-bold" }, [
                          _vm._v(_vm._s(_vm.$t("log.selectedPreviewImage")))
                        ]),
                        _vm._v(" "),
                        _c("q-img", {
                          staticClass: "col-12 col-md-auto log-teaser-image",
                          staticStyle: { width: "100%" },
                          attrs: {
                            src: _vm.watchlistItem.teaser,
                            position: "50% 100%",
                            ratio: "2.666666666666667",
                            contain: ""
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "q-btn",
                          {
                            staticClass: "absolute-top-right teaser-selector",
                            staticStyle: { top: "10px", right: "30px" },
                            attrs: { icon: "photo", flat: "", dense: "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.resetTeaser.apply(null, arguments)
                              }
                            }
                          },
                          [
                            _c("q-tooltip", [
                              _vm._v(
                                _vm._s(_vm.$t("tooltip.resetPreviewImage"))
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("q-checkbox", {
                      attrs: {
                        value: _vm.allImagesSelected,
                        label: _vm.$t("label.toggleAllLogImages")
                      },
                      on: { input: _vm.toggleAll }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("veneer-log-images", {
                      attrs: {
                        images: _vm.allSmallImages,
                        large: _vm.large,
                        selectable: ""
                      },
                      on: { "select-image": _vm.toggleImageExclusion },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "imageActions",
                            fn: function(slotProps) {
                              return [
                                _c("q-checkbox", {
                                  staticClass: "absolute",
                                  staticStyle: { top: "16px", left: "20px" },
                                  attrs: {
                                    value: _vm.checkBoxValue(slotProps.image),
                                    color: "primary",
                                    "keep-color": ""
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.toggleImageExclusion(
                                        slotProps.imageIndex
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "q-btn",
                                  {
                                    staticClass:
                                      "absolute-top-right teaser-selector",
                                    class: _vm.teaserSelectorClass(
                                      slotProps.image
                                    ),
                                    staticStyle: { top: "20px", right: "10px" },
                                    attrs: {
                                      icon: "photo",
                                      flat: "",
                                      dense: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.setTeaser(slotProps.image)
                                      }
                                    }
                                  },
                                  [
                                    _c("q-tooltip", [
                                      _vm._v(
                                        _vm._s(_vm.$t("tooltip.asPreviewImage"))
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1588655453
                      )
                    })
                  ],
                  1
                )
              ]
            : _vm.loading
            ? _c(
                "div",
                { staticClass: "text-center q-my-md" },
                [
                  _c("q-spinner-cube", {
                    attrs: { color: "primary", size: "3em" }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }